import { render, staticRenderFns } from "./DisplayImageManagement.vue?vue&type=template&id=16c55c5a&scoped=true"
import script from "./DisplayImageManagement.vue?vue&type=script&lang=js"
export * from "./DisplayImageManagement.vue?vue&type=script&lang=js"
import style0 from "./DisplayImageManagement.vue?vue&type=style&index=0&id=16c55c5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c55c5a",
  null
  
)

export default component.exports